export const checkUserRole = async (role) => {
  const usuarioLogado = await JSON.parse(localStorage[`_immortal|usuarioLogado`] || null);

  return usuarioLogado && usuarioLogado?.authorities.some(authority => {
    return authority?.authority === role;
  });
};
